import { render, staticRenderFns } from "./DictionaryMngtDtl.vue?vue&type=template&id=e05c75aa"
import script from "./DictionaryMngtDtl.vue?vue&type=script&lang=js"
export * from "./DictionaryMngtDtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports